/// <reference types="@types/google.maps" />
import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {MapLocations} from '../../../domain/cloud-topology';

const enum MARKER_SIZE {
  LENGTH = 25,
  WIDTH = 40
}

const MAP_MAX_ZOOM = 16;

const TEAL_PIN_PATH = '../../../../assets/img/teal-pin.png';


@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    standalone: false
})
export class MapComponent implements OnChanges {
  @Input() mapLocations: MapLocations[];
  @ViewChild('map', { static: true }) mapElement: any;

  private mapObject: google.maps.Map;
  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mapLocations']['currentValue']) {
      this.mapLocations = changes['mapLocations']['currentValue'];
      this.updateMap();
    }
  }

  updateMap(): void {
    this.mapObject = new google.maps.Map(this.mapElement.nativeElement, {
      maxZoom: MAP_MAX_ZOOM,
      mapTypeId: google.maps.MapTypeId.SATELLITE,
    });
    this.mapObject.setTilt(45);

    this.setMapBounds();
    this.addMarkers();
  }



  private setMapBounds(): void {
    const polyCoords = [];
    const bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
    for (const mapLocation of this.mapLocations) {
      if (mapLocation.lat && mapLocation.long) {
          bounds.extend(new google.maps.LatLng(parseFloat(mapLocation.lat), parseFloat(mapLocation.long)));
          polyCoords.push({
            lat: parseFloat(mapLocation.lat),
            lng: parseFloat(mapLocation.long)
          });
      }
    }
    this.mapObject.fitBounds(bounds);

   const poly =  new google.maps.Polygon({
     paths: polyCoords,
     strokeColor: '#FF0000',
     strokeOpacity: 0.8,
     strokeWeight: 3,
     fillColor: '#FF0000',
     fillOpacity: 0.35
   });
   poly.setMap(this.mapObject);
  }

  private addMarkers(): void {
    for (const mapLocation of this.mapLocations) {
      if (mapLocation.lat && mapLocation.long) {
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(parseFloat(mapLocation.lat), parseFloat(mapLocation.long)),
          icon: {url: TEAL_PIN_PATH, scaledSize: new google.maps.Size(MARKER_SIZE.LENGTH, MARKER_SIZE.WIDTH)},
        });

        if (mapLocation.description && mapLocation.description.length > 0) {

          const infoWindow = new google.maps.InfoWindow({
            content: mapLocation.description
          });

          marker.addListener('click', function() {
            infoWindow.open(this.getMap(), marker);
          });
        }
        marker.setMap(this.mapObject);
      }
    }
  }
}
